import * as React from 'react';
import debounce from 'lodash.debounce';

interface Props {
  onFetchMore: () => void;
  children: React.ReactNode;
}

class InfiniteScroll extends React.Component<Props> {
  public componentDidMount() {
    globalThis.document.addEventListener('scroll', this.onScroll);
  }

  public componentWillUnmount() {
    globalThis.document.removeEventListener('scroll', this.onScroll);
  }

  private onScroll = debounce(() => {
    const { onFetchMore } = this.props;
    const scrollingElement =
      globalThis.document.scrollingElement || globalThis.document.documentElement;
    const scrollY = Math.round(scrollingElement.scrollTop + globalThis.innerHeight);
    const bottomY = scrollingElement.scrollHeight;

    if (scrollY >= bottomY) {
      onFetchMore();
    }
  }, 150);

  public render() {
    const { children } = this.props;
    return children;
  }
}

export default InfiniteScroll;
